module.exports = __webpack_public_path__ + "static/media/pack2.797e428e.png";